import {
    Box, Dialog,
    DialogContent, LinearProgress, Link
} from "@mui/material";
import bn_logo from 'assets/bn-logo-black.png'
import polona_logo from 'assets/polona-logo.jpg'
import omnis_logo from 'assets/logo-omnis.png'
import mlumen_logo from 'assets/mlumen-logo.svg'
import {translateKey} from "utils/fieldsFormatters";
import { Suspense, use } from "react";
import {LanguageContext} from "context/LanguageContext";
import {
    DescriptorType,
    KATALOG_BN_BASE_URL,
    KATALOG_BN_SUFFIX_URL,
    POLONA_BASE_URL,
    OMNIS_URL,
    MLUMEN_URL
} from "consts/khw-consts";
import DialogTitleWithCloseIcon from "../../common/DialogTitleWithCloseIcon";


interface LinksDialogProps {
    open: boolean
    onClose: () => void
    nlpId: string
    descriptorName: string
    descriptorType: DescriptorType
    preferredNameForFuzzySearch: string

}


const LinksDialog = ({open, onClose, nlpId, descriptorName, descriptorType, preferredNameForFuzzySearch}: LinksDialogProps) => {
    const {language} = use(LanguageContext);

    const generatePolonaUrl = () => {
        if ([DescriptorType.PERSONAL, DescriptorType.CORPORATE, DescriptorType.EVENT].includes(descriptorType)){
            return `${POLONA_BASE_URL}searchCategory=objectSets&page=0&size=24&sort=RELEVANCE&searchLike=${preferredNameForFuzzySearch}&copyright=false`;
        }
        return `${POLONA_BASE_URL}searchCategory=&page=0&size=24&sort=OLDEST&criteria.keywords.exact=${preferredNameForFuzzySearch}&copyright=false`;
    }

    const generateKatalogBNUrl = () =>
        `${KATALOG_BN_BASE_URL}${descriptorName}${KATALOG_BN_SUFFIX_URL}`
    const generateOmnisUrl = () => {

        const validType = descriptorType === DescriptorType.GEOGRAPHIC ? 'geographical_descriptor' : descriptorType
        return `${OMNIS_URL}/${validType}/${nlpId}`
    }

    const generatemLUMENUrl = () => `${MLUMEN_URL}/topic/${nlpId}`


    const renderLinkBox = (href: string, logo: string, alt: string) =>
        <Link target="_blank" className={'dialog-link'} title={translateKey('linkOpeningPageInNewTab', language)}
              href={href}>{alt}<img src={logo} height={30} alt={alt} aria-label={alt}/></Link>

    return <Dialog open={open} onClose={onClose} fullWidth maxWidth={'sm'}>

        <Suspense fallback={<Box sx={{width: '100%'}}>
            <LinearProgress/>
        </Box>}><DialogTitleWithCloseIcon title={translateKey('descriptorInfo.seeBNServices', language)}
                                          onClose={onClose}/></Suspense>
        <DialogContent>

            <Box className={'links-box'} textAlign={"center"}>
                {renderLinkBox(generateKatalogBNUrl(), bn_logo, translateKey('BNCatalog', language))}
                {renderLinkBox(generatePolonaUrl(), polona_logo, translateKey('polonaLibrary', language))}
                {renderLinkBox(generateOmnisUrl(), omnis_logo, 'ZW OMNIS')}
                {renderLinkBox(generatemLUMENUrl(), mlumen_logo, 'mLUMEN')}
            </Box>
        </DialogContent>
    </Dialog>
}

export default LinksDialog